module.exports = __webpack_public_path__ + "9fb31dcf07df1b521cb0002c566f473a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/home-2.svg
// module id = 482
// module chunks = 0